module.exports = __webpack_public_path__ + "static/media/review-1.92709f3c.png";